import React from 'react';
import { PureComponent } from '../../../dispatcher/modules';
import { TEXT_COMPONENT_PROPS } from './Types';
import classNames from 'classnames';
import * as _ from 'lodash';

class TextComponent extends PureComponent<TEXT_COMPONENT_PROPS> {
  static defaultProps = {
    htmlTag: 'div',
    color: 'default'
  };

  render() {
    const {
      htmlTag = 'div',
      href,
      size,
      color = 'default',
      className = '',
      decorator,
      thickness
    } = this.props;
    const colorAsArray = _.isArray(color) && color.length === 2;

    let correctedHref = undefined;
    let htmlTagLinkTarget = undefined;

    if (htmlTag === 'a') {
      // Ensure that href starts with either "http://" or "https://"
      correctedHref = href && typeof href === 'string' && !href.startsWith('http://') && !href.startsWith('https://')
        ? `https://${href}`
        : href;
      htmlTagLinkTarget = '_blank';
    }

    const textCls = classNames(
      `tp-text-cmp ${className}`,
      {
        'tp-text-semibold': thickness === 'semi-bold',
        'tp-text-medium': thickness === 'medium',
        'tp-text-bold': thickness === 'bold',
        'tp-text-underline': decorator === 'underline',
        'tp-text-line-trough': decorator === 'line-through',
        'tp-color-default': color === 'default',
        'tp-color-accent': color === 'primary' || color === 'info',
        'tp-color-error': color === 'negative',
        'tp-color-success': color === 'positive',
        'tp-favorite-color': color === 'warning',
        'tp-font-size-sm': size === 'sm',
        'tp-font-size-md': size === 'md',
        'tp-font-size-lg': size === 'lg',
        'tp-font-size-xl': size === 'xl',
        'tp-font-size-xxl': size === 'xxl',
        'tp-font-size-h3': size === 'h3',
        'tp-font-size-h2': size === 'h2',
        'tp-font-size-h1': size === 'h1',
        'tp-link': htmlTag === 'a',
        [`tp-color-${color[0]}-${color[1]}`]: colorAsArray && color
      }
    );

    const elementRealProps = _.omit(this.props, ['size', 'color', 'thickness', 'decorator', 'htmlTag']);

    return (
      React.createElement(htmlTag, { 
        ...elementRealProps, 
        className: textCls, 
        href: correctedHref,
        target: htmlTagLinkTarget
      })
    );
  }
}

export default TextComponent;
